import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";
import { useClientApiKeys } from "@hooks/useClientSettings";
import { appVersion, envMode, apiUrlOriginacaoDefault } from "@settings";
import { useEffect, useRef, useMemo } from "react";

export const DataDogProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { dataDog } = useClientApiKeys();

  const hasInitialized = useRef(false);
  const plugin = useMemo(() => reactPlugin({ router: true }), []);

  useEffect(() => {
    const { applicationId, clientToken, serviceName } = dataDog ?? {};

    if (
      hasInitialized.current ||
      !applicationId ||
      !clientToken ||
      !serviceName
    ) {
      return;
    }

    hasInitialized.current = true;

    datadogRum.init({
      applicationId,
      clientToken,
      site: "datadoghq.com",
      service: serviceName,
      env: envMode,
      version: appVersion,
      sessionSampleRate: 5,
      sessionReplaySampleRate: 0,
      defaultPrivacyLevel: "mask-user-input",
      plugins: [plugin],
      allowedTracingUrls: [apiUrlOriginacaoDefault],
    });
  }, [dataDog, plugin]);

  return <>{children}</>;
};
